import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { useLanguage } from '../i18n/LanguageContext';
import { Users, Heart, Globe, Sprout, HandHeart } from 'lucide-react';

const CommunitySupportPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Navbar />
      <WhatsAppButton />

      {/* Header */}
      <section className="pt-32 pb-12 bg-gradient-to-b from-rose-600 to-rose-700">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <Heart className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">{t('community.title')}</h1>
          <p className="text-white/80 text-lg max-w-2xl mx-auto">{t('community.subtitle')}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="container mx-auto px-4 md:px-6 max-w-3xl space-y-6">
          {/* Main statement */}
          <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 bg-rose-50 rounded-full flex items-center justify-center flex-shrink-0">
                <Users className="w-6 h-6 text-rose-600" />
              </div>
              <p className="text-gray-700 leading-relaxed text-lg pt-2">{t('community.p1')}</p>
            </div>
          </div>

          {/* Traveler invitation */}
          <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 bg-amber-50 rounded-full flex items-center justify-center flex-shrink-0">
                <Globe className="w-6 h-6 text-amber-600" />
              </div>
              <p className="text-gray-700 leading-relaxed text-lg pt-2">{t('community.p2')}</p>
            </div>
          </div>

          {/* Environmental education */}
          <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 bg-emerald-50 rounded-full flex items-center justify-center flex-shrink-0">
                <Sprout className="w-6 h-6 text-emerald-600" />
              </div>
              <p className="text-gray-700 leading-relaxed text-lg pt-2">{t('community.p3')}</p>
            </div>
          </div>

          {/* Closing card */}
          <div className="bg-gradient-to-br from-rose-500 to-rose-700 rounded-2xl p-8 text-center text-white shadow-lg mt-10">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-white/15 rounded-full mb-4">
              <HandHeart className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-2xl font-bold mb-3">{t('community.closingTitle')}</h3>
            <p className="text-white/90 max-w-xl mx-auto">{t('community.closingText')}</p>
            <div className="mt-4 text-2xl">❤️ 🇨🇷</div>
          </div>

          <p className="text-center text-gray-400 text-sm mt-10">{t('community.lastUpdated')}</p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CommunitySupportPage;
